import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_9d66c3ppvh: FaireCollectionEntity = {
  token: "pbc_9d66c3ppvh",
  type: "collection",
  name: "JB Maternity",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c3476615a88124fa5cc8c3cab107052d4716146dfd4c63ba0f3c3661db22b33c.png",
  itemCount: 5,
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:16.185Z",
    importedBy: "entity-db-import-collections",
  },
};
